import $ from 'jquery';

/*
 * $.ifExists()
 *
 * Check if an Element exists in the DOM
 * and calls the callback function. With
 * the elements if it does.
 *
 * @usage:
 * $.ifExists('body', function (iteml) { alert(iteml.prop("tagName")); })
 *
 * or
 *
 * if ($.ifExists('body')) { alert('Hello World!'); }
 */

$.ifExists = function ifExists(items, cb) {
    if ($.isArray(items)) {
        var size = items.length,
            elements = [],
            $elements;

        if (size < 0) {
            return false;
        }

        for (var i=0, $element; i < size; i++) {
            $element = ifExists(items[i]);

            if (!$element) { // Exit early when there's no element found
                return false;
            }

            elements.push($element);
        }

        $elements = $(elements);

        if (cb) {
            cb.apply($elements, elements);
        }

        return $elements;
    }

    if (items instanceof $ === false) {
        items = $(items);
    }

    if (items.length < 1) {
        return false; // Exit
    }

    if (cb) {
        cb.call(items, items);
    }

    return items;
};

export default ifExists;